import { Base, Component } from '@/vue-property-decorator'
import CompanyInfo from '../../companyInfo'
import ContactUs from '../../contactUs'
import CopyShare from '../../copyRight'
import LinkList, { sortMap } from '../../linkList'
import LogoArea from '../../logoArea'
import OfficialChannel from '../../officialChannel'
import PhotographImg from '../../photographImgBox'
import style from './style.module.scss'

// theme1对应美术欧美版
@Component<FooterLayout1>({ name: 'FooterLayout1' })
export default class FooterLayout1 extends Base {
  render() {
    const filterArr = [sortMap.RecreationCity, sortMap.Game, sortMap.Support]
    return (
      <div class={style.layout1BoxH5}>
        <LinkList
          layoutType={'vertical'}
          filterArr={filterArr}
          isNeedSeparateAboutUs={false}
        />
        <ContactUs showTitle={true} long={70} />
        <OfficialChannel />
        <CompanyInfo />
        <LogoArea />
        <PhotographImg />
        <CopyShare />
      </div>
    )
  }
}
